import _ from "lodash";
import { getArbeitsplanTitle } from "../../utils/helperFunctions";
import {
  AbwesendMitarbeiter,
  ArbeitsplanType,
  Terminarten,
  UserType,
} from "../../utils/types";
import moment from "moment";

export const filterKurzubersichtBaustellenansicht = (
  filteredData: ArbeitsplanType[],
) => {
  const grouped = _.mapValues(
    _.groupBy(
      filteredData
        .map((item) => {
          if (item.terminart === Terminarten["Urlaub"]) {
            return { ...item, kunde_name: "Urlaub" };
          } else if (item.terminart === Terminarten["Termin außer Haus"]) {
            return { ...item, kunde_name: "Termin außer Haus" };
          } else if (
            item.terminart === Terminarten["Schule"] ||
            item.terminart === Terminarten["Weiterbildung"]
          ) {
            return { ...item, kunde_name: "Schule" };
          }
          return item;
        })
        .filter(
          (x) =>
            x.terminart !== Terminarten["Freizeitausgleich (angefragt)"] &&
            x.terminart !== Terminarten["Urlaubsanfrage"] &&
            x.terminart !== Terminarten["Krank"] &&
            x.terminart !== Terminarten["Freizeitausgleich"] &&
            x.terminart !== Terminarten["überbetriebliche Unterweisung"] &&
            x.terminart !== Terminarten["Prüfung"] &&
            x.terminart !== Terminarten["Feiertag"] &&
            x.terminart !== Terminarten["Baustellentermin"] &&
            x.terminart !== Terminarten["Baubesprechung"] &&
            x.terminart !== Terminarten["Besprechungstermin"] &&
            x.terminart !== Terminarten["Arbeitsunfall"] &&
            x.terminart !== Terminarten["Vergabetermin"] &&
            x.terminart !== Terminarten["Ankündigung"],
        ),
      "bauleiter",
    ),
    (bauleiterGroup) =>
      _.mapValues(_.groupBy(bauleiterGroup, "objekt"), (objektGroup) =>
        _.mapValues(
          _.groupBy(objektGroup, "kunde_name"),
          //, (kundeGroup) =>          _.mapValues(_.groupBy(kundeGroup, "terminart"))
        ),
      ),
  );
  const flattenedKundeNames = _.flatMap(
    _.flatMapDeep(grouped, (bauleiterGroup) =>
      _.flatMapDeep(
        bauleiterGroup,
        (objektGroup) => objektGroup,
        //_.flatMapDeep(objektGroup, (kundeGroup) => kundeGroup)
      ),
    ),
    (obj) => Object.values(obj),
  );
  return flattenedKundeNames.sort((a, b) =>
    getArbeitsplanTitle(a[0])?.localeCompare(getArbeitsplanTitle(b[0])),
  );
};

export const filterKurzubersichtMitarbeiteransicht = (
  filteredData: ArbeitsplanType[],
  allUsers: UserType[],
) => {
  const grouped = _.mapValues(
    _.groupBy(
      filteredData
        .filter(
          (x) =>
            x.terminart !== Terminarten["Freizeitausgleich (angefragt)"] &&
            x.terminart !== Terminarten["Urlaubsanfrage"] &&
            x.terminart !== Terminarten["Krank"] &&
            x.terminart !== Terminarten["Feiertag"] &&
            x.terminart !== Terminarten["Arbeitsunfall"] &&
            x.terminart !== Terminarten["Ankündigung"],
        )
        .flatMap((item) =>
          item.mitarbeiter.split(",").map((mitarbeiter) => ({
            ...item,
            mitarbeiter: mitarbeiter.trim(),
          })),
        ),
      "mitarbeiter",
    ),
    (bauleiterGroup) =>
      _.mapValues(_.groupBy(bauleiterGroup, "objekt"), (objektGroup) =>
        _.mapValues(
          _.groupBy(objektGroup, "kunde_name"),
          //, (kundeGroup) =>          _.mapValues(_.groupBy(kundeGroup, "terminart"))
        ),
      ),
  );
  const flattenedKundeNames: ArbeitsplanType[][] = _.flatMap(
    _.flatMapDeep(grouped, (bauleiterGroup) =>
      _.flatMapDeep(bauleiterGroup, (objektGroup) => objektGroup),
    ),
    (obj) => Object.values(obj),
  );
  let mitarbeiterAnsicht: {
    [mitarbeiternummer: string]: {
      user: UserType;
      workplansList: ArbeitsplanType[][];
    };
  } = {};

  flattenedKundeNames.forEach((workplanGroup) => {
    if (!mitarbeiterAnsicht[workplanGroup[0].mitarbeiter.trim()]) {
      mitarbeiterAnsicht[workplanGroup[0].mitarbeiter.trim()] = {
        user: null,
        workplansList: [],
      };
    }
    mitarbeiterAnsicht[workplanGroup[0].mitarbeiter.trim()].user =
      allUsers.find(
        (user) =>
          user.mitarbeiternummer.toString().trim() ===
          workplanGroup[0].mitarbeiter.trim(),
      );
    mitarbeiterAnsicht[workplanGroup[0].mitarbeiter.trim()].workplansList.push(
      workplanGroup,
    );
  });
  return Object.keys(mitarbeiterAnsicht)
    .sort((a, b) => {
      const userA = mitarbeiterAnsicht[a].user;
      const userB = mitarbeiterAnsicht[b].user;
      if (userA && userB) {
        return userA.username?.localeCompare(userB.username);
      }
      return 0;
    })
    .reduce((acc, key) => {
      const user = mitarbeiterAnsicht[key].user;
      if (user) {
        acc[user.username] = mitarbeiterAnsicht[key];
      }
      return acc;
    }, {});
};

export const filterBauArbeitsplane = (
  groupedData: ArbeitsplanType[][],
  mbNummer?: string,
) => {
  const filteredData = groupedData
    .map((wpl) =>
      wpl.filter(
        (x) =>
          x.terminart === Terminarten["Bau (tägl. Fahrten)"] ||
          x.terminart === Terminarten["Bau (Rheine)"] ||
          x.terminart === Terminarten["Werkstatt"],
      ),
    )
    .filter(
      (x) =>
        x.length > 0 &&
        (!mbNummer ||
          x.some((plan) => plan.mitarbeiter.includes(mbNummer.trim()))),
    );

  return filteredData.sort((a, b) => {
    const dateComparison =
      moment(a[0].datum, "YYYY-MM-DD").unix() -
      moment(b[0].datum, "YYYY-MM-DD").unix();
    if (dateComparison !== 0) {
      return dateComparison;
    }
    return (
      moment(a[0].zeitvon, "HH:mm:ss.SSSSSSS").unix() -
      moment(b[0].zeitvon, "HH:mm:ss.SSSSSSS").unix()
    );
  });
};

export const filterMontageArbeitsplane = (
  groupedData: ArbeitsplanType[][],
  mbNummer?: string,
) => {
  const filteredData = groupedData
    .map((wpl) =>
      wpl.filter((x) => x.terminart === Terminarten["Bau (Montage)"]),
    )
    .filter(
      (x) =>
        x.length > 0 &&
        (!mbNummer ||
          x.some((plan) => plan.mitarbeiter.includes(mbNummer.trim()))),
    );

  return filteredData.sort((a, b) => {
    const dateComparison =
      moment(a[0].datum, "YYYY-MM-DD").unix() -
      moment(b[0].datum, "YYYY-MM-DD").unix();
    if (dateComparison !== 0) {
      return dateComparison;
    }
    return (
      moment(a[0].zeitvon, "HH:mm:ss.SSSSSSS").unix() -
      moment(b[0].zeitvon, "HH:mm:ss.SSSSSSS").unix()
    );
  });
};

export const filterPVArbeitsplane = (
  groupedData: ArbeitsplanType[][],
  mbNummer?: string,
) => {
  const filteredData = groupedData
    .map((wpl) =>
      wpl.filter((x) => x.terminart === Terminarten["PV-Abteilung"]),
    )
    .filter(
      (x) =>
        x.length > 0 &&
        (!mbNummer ||
          x.some((plan) => plan.mitarbeiter.includes(mbNummer.trim()))),
    );
  return filteredData.sort((a, b) => {
    const dateComparison =
      moment(a[0].datum, "YYYY-MM-DD").unix() -
      moment(b[0].datum, "YYYY-MM-DD").unix();
    if (dateComparison !== 0) {
      return dateComparison;
    }
    return (
      moment(a[0].zeitvon, "HH:mm:ss.SSSSSSS").unix() -
      moment(b[0].zeitvon, "HH:mm:ss.SSSSSSS").unix()
    );
  });
};

export const filterKundendienstArbeitsplane = (
  groupedData: ArbeitsplanType[][],
  mbNummer?: string,
) => {
  const filteredData = groupedData
    .map((wpl) =>
      wpl.filter(
        (x) =>
          x.terminart === Terminarten["Kundendienst (FEST)"] ||
          x.terminart === Terminarten["Laden"] ||
          x.terminart === Terminarten["Kundendienst (verschiebbar)"],
      ),
    )
    .filter(
      (x) =>
        x.length > 0 &&
        (!mbNummer ||
          x.some((plan) => plan.mitarbeiter.includes(mbNummer.trim()))),
    );

  return filteredData.sort((a, b) => {
    const dateComparison =
      moment(a[0].datum, "YYYY-MM-DD").unix() -
      moment(b[0].datum, "YYYY-MM-DD").unix();
    if (dateComparison !== 0) {
      return dateComparison;
    }
    return (
      moment(a[0].zeitvon, "HH:mm:ss.SSSSSSS").unix() -
      moment(b[0].zeitvon, "HH:mm:ss.SSSSSSS").unix()
    );
  });
};

export const filterWartungArbeitsplane = (
  groupedData: ArbeitsplanType[][],
  mbNummer?: string,
) => {
  const filteredData = groupedData
    .map((wpl) =>
      wpl.filter(
        (x) =>
          x.terminart === Terminarten["Wartung"] ||
          x.terminart === Terminarten["Störung"],
      ),
    )
    .filter(
      (x) =>
        x.length > 0 &&
        (!mbNummer ||
          x.some((plan) => plan.mitarbeiter.includes(mbNummer.trim()))),
    );

  return filteredData.sort((a, b) => {
    const dateComparison =
      moment(a[0].datum, "YYYY-MM-DD").unix() -
      moment(b[0].datum, "YYYY-MM-DD").unix();
    if (dateComparison !== 0) {
      return dateComparison;
    }
    return (
      moment(a[0].zeitvon, "HH:mm:ss.SSSSSSS").unix() -
      moment(b[0].zeitvon, "HH:mm:ss.SSSSSSS").unix()
    );
  });
};

export const filterFortbildungen = (
  filteredData: ArbeitsplanType[],
  mbNummer?: string,
): ArbeitsplanType[][] => {
  const grouped = _.mapValues(
    _.groupBy(
      filteredData.filter(
        (x) =>
          x.terminart === Terminarten["Schule"] ||
          x.terminart === Terminarten["Weiterbildung"] ||
          x.terminart === Terminarten["überbetriebliche Unterweisung"] ||
          x.terminart === Terminarten["Prüfung"],
      ),
      (x) => `${x.gesamttermindatumvon}-${x.gesamttermindatumbis}`,
    ),
    (dateRangeGroup) => _.groupBy(dateRangeGroup, "mitarbeiter"),
  );
  const flattenedMitarbeiter = _.flatMap(
    _.flatMapDeep(grouped, (dateRangeGroup) => dateRangeGroup),
    (obj) => Object.values(obj),
  );
  return flattenedMitarbeiter.sort((a, b) => {
    const dateComparison =
      moment(a[0].datum, "YYYY-MM-DD").unix() -
      moment(b[0].datum, "YYYY-MM-DD").unix();
    if (dateComparison !== 0) {
      return dateComparison;
    }
    return (
      moment(a[0].zeitvon, "HH:mm:ss.SSSSSSS").unix() -
      moment(b[0].zeitvon, "HH:mm:ss.SSSSSSS").unix()
    );
  });
};

export const filterNotdienst = (
  filteredData: ArbeitsplanType[],
  mbNummer?: string,
) => {
  return filteredData
    .filter(
      (x) =>
        x.terminart === Terminarten["Notdienst"] &&
        (!mbNummer || x.mitarbeiter.includes(mbNummer.trim())),
    )
    .sort((a, b) => {
      const dateComparison =
        moment(a[0]?.datum, "YYYY-MM-DD").unix() -
        moment(b[0]?.datum, "YYYY-MM-DD").unix();
      if (dateComparison !== 0) {
        return dateComparison;
      }
      return (
        moment(a[0]?.zeitvon, "HH:mm:ss.SSSSSSS").unix() -
        moment(b[0]?.zeitvon, "HH:mm:ss.SSSSSSS").unix()
      );
    });
};

export const filterAbwesend = (
  filteredData: ArbeitsplanType[],
  users: UserType[],
  allowedTerminarten: string[],
): AbwesendMitarbeiter[] => {
  const abwesend = Array.from(
    new Set(
      filteredData
        .filter((x) => allowedTerminarten.includes(x.terminart))
        .flatMap((x) => x.mitarbeiter.split(",")),
    ),
  );
  let abwesendMitarbeiter: AbwesendMitarbeiter[] = [];
  abwesend.forEach((mbNummer) => {
    const mitarbeiter = users.filter(
      (user) => user.mitarbeiternummer.toString() === mbNummer?.trim(),
    )[0];
    if (mitarbeiter && mitarbeiter.last_name && mitarbeiter.first_name) {
      let name =
        mitarbeiter.last_name +
        ", " +
        mitarbeiter.first_name?.slice(0, 2) +
        ".";
      const termin = filteredData.find(
        (x) =>
          x.mitarbeiter.includes(mbNummer?.trim()) &&
          x.terminart !== Terminarten["Krank"] &&
          x.terminart !== Terminarten["Arbeitsunfall"] &&
          allowedTerminarten.includes(x.terminart),
      );
      let dateRange: string | null = null;
      if (termin) {
        dateRange =
          "" +
          moment(termin.gesamttermindatumvon, "YYYY-MM-DD").format("DD.MM.");
        if (
          termin.gesamttermindatumbis &&
          termin.gesamttermindatumbis != termin.gesamttermindatumvon
        )
          dateRange += moment(termin.gesamttermindatumbis, "YYYY-MM-DD").format(
            " - DD.MM.",
          );
      }
      abwesendMitarbeiter.push({ name, dateRange });
    }
  });
  return abwesendMitarbeiter.sort((a, b) => a.name?.localeCompare(b.name));
};

export const filterBaustellentermiene = (
  groupedData: ArbeitsplanType[][],
  currentUser,
  mbNummer?: string,
) => {
  const filteredData = groupedData
    .map((wpl) =>
      wpl.filter(
        (x) =>
          x.terminart === Terminarten["Baustellentermin"] ||
          x.terminart === Terminarten["Termin außer Haus"] ||
          x.terminart === Terminarten["Baubesprechung"] ||
          x.terminart === Terminarten["Besprechungstermin"] ||
          x.terminart === Terminarten["Vergabetermin"] ||
          x.terminart === Terminarten["Teamsbesprechung ( VIKO )"],
      ),
    )
    .filter((x) => x.length > 0);
  if (
    currentUser &&
    currentUser.bemerkung === "GF" // || currentUser.bemerkung === "Personal")
  ) {
    return filteredData.sort((a, b) => {
      const dateComparison =
        moment(a[0].datum, "YYYY-MM-DD").unix() -
        moment(b[0].datum, "YYYY-MM-DD").unix();
      if (dateComparison !== 0) {
        return dateComparison;
      }
      return (
        moment(a[0].zeitvon, "HH:mm:ss.SSSSSSS").unix() -
        moment(b[0].zeitvon, "HH:mm:ss.SSSSSSS").unix()
      );
    });
  } else
    return filteredData
      .filter((x) =>
        x.some((ap) =>
          ap.mitarbeiter.includes(currentUser.mitarbeiternummer.toString()),
        ),
      )
      .sort((a, b) => {
        const dateComparison =
          moment(a[0].datum, "YYYY-MM-DD").unix() -
          moment(b[0].datum, "YYYY-MM-DD").unix();
        if (dateComparison !== 0) {
          return dateComparison;
        }
        return (
          moment(a[0].zeitvon, "HH:mm:ss.SSSSSSS").unix() -
          moment(b[0].zeitvon, "HH:mm:ss.SSSSSSS").unix()
        );
      });
};
export const filterAnkundigungen = (filteredData: ArbeitsplanType[]) => {
  return filteredData
    .filter((x): x is ArbeitsplanType => {
      if (!x) return false;
      return (
        x.terminart === Terminarten["Ankündigung"] &&
        moment(x.datum || "2000-01-01").add(1, "day") >= moment()
      );
    })
    .sort((a, b) => {
      const dateA = moment(a?.datum || "2000-01-01", "YYYY-MM-DD").unix();
      const dateB = moment(b?.datum || "2000-01-01", "YYYY-MM-DD").unix();
      const dateComparison = dateA - dateB;

      if (dateComparison !== 0) {
        return dateComparison;
      }

      const timeA = moment(a?.zeitvon || "00:00:00", "HH:mm:ss.SSSSSSS").unix();
      const timeB = moment(b?.zeitvon || "00:00:00", "HH:mm:ss.SSSSSSS").unix();
      return timeA - timeB;
    });
};

export const groupWorkplan = (unfilteredData: ArbeitsplanType[]) => {
  const grouped = _.mapValues(
    _.groupBy(
      unfilteredData.filter((x) => x.bauleiter || x.objekt || x.kunde_name),
      "bauleiter",
    ),
    (bauleiterGroup) =>
      _.mapValues(_.groupBy(bauleiterGroup, "objekt"), (objektGroup) =>
        _.groupBy(objektGroup, "kunde_name"),
      ),
  );

  const groupedFlattened = _.flatMap(
    _.flatMapDeep(grouped, (bauleiterGroup) =>
      _.flatMapDeep(bauleiterGroup, (objektGroup) => objektGroup),
    ),
    (obj) => Object.values(obj),
  );

  const ungrouped = unfilteredData.filter(
    (x) => !x.bauleiter && !x.objekt && !x.kunde_name,
  );

  const flattenedKundeNames = [
    ...groupedFlattened,
    ...ungrouped.map((item) => [item]),
  ];
  return flattenedKundeNames;
};
